import { createFileRoute, Link } from "@tanstack/react-router";
import { ctrDesc, ctrTitle } from "@/lib/seo-copy";
import { VISA_COMPARE } from "@/data/visa/compare";
import { absoluteUrl } from "@/config/sites";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const TITLE = "เทียบทางเลือกแปลและรับรองเอกสารยื่นวีซ่า";
const DESC =
  "เลือกชั้นการรับรองคำแปลให้ถูกตั้งแต่ครั้งแรก เทียบคำรับรองผู้แปล นิติกรณ์กรมการกงสุล การรับรองสถานทูตปลายทาง และผู้แปลที่สถานทูตขึ้นบัญชี สอบถามทีมงานได้ทาง LINE";

export const Route = createFileRoute("/visa/compare/")({
  loader: () => {
    const url = absoluteUrl("/visa/compare");
    return {
      h: {
        meta: [
          { title: ctrTitle(TITLE) },
          { name: "description", content: ctrDesc(DESC) },
          { property: "og:title", content: ctrTitle(TITLE) },
          { property: "og:description", content: ctrDesc(DESC) },
          { property: "og:url", content: url },
          { property: "og:type", content: "website" },
          { name: "twitter:card", content: "summary" },
        ],
        links: [{ rel: "canonical", href: url }],
        scripts: [
          {
            type: "application/ld+json",
            children: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "ItemList",
              name: TITLE,
              itemListElement: VISA_COMPARE.map((c, i) => ({
                "@type": "ListItem",
                position: i + 1,
                name: c.h1,
                url: absoluteUrl(`/visa/compare/${c.slug}`),
              })),
            }),
          },
        ],
      },
    };
  },
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: VisaCompareHub,
});

function VisaCompareHub() {
  return (
    <>
      <Breadcrumbs jsonLd
        items={[
          { label: "หน้าแรก", to: "/" },
          { label: "วีซ่า", to: "/visa" },
          { label: "เทียบทางเลือก" },
        ]}
      />
      <section className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="text-3xl font-bold mb-5">{TITLE}</h1>
        <p className="answer-summary text-lg mb-8 p-4 bg-muted rounded-xl" data-speakable>
          เอกสารยื่นวีซ่าถูกตีกลับบ่อยที่สุดเพราะเลือกชั้นการรับรองผิด ไม่ใช่เพราะแปลไม่ดี
          แต่ละหน้าด้านล่างสรุปคำตอบไว้ด้านบน พร้อมตารางเทียบทีละข้อ ค่าธรรมเนียมราชการตามอัตราจริง
          และคำถามที่พบบ่อย
        </p>

        <ul className="space-y-4">
          {VISA_COMPARE.map((c) => (
            <li key={c.slug} className="border rounded-xl p-5">
              <h2 className="font-semibold mb-1">
                <Link to="/visa/compare/$slug" params={{ slug: c.slug }} className="text-primary hover:underline">
                  {c.h1}
                </Link>
              </h2>
              <p className="text-sm text-muted-foreground">{c.description}</p>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-sm">
          <Link to="/visa/questions" className="text-primary hover:underline">
            คำถามที่พบบ่อยเรื่องวีซ่าและเอกสาร
          </Link>
          {" · "}
          <Link to="/sworn/compare" className="text-primary hover:underline">
            เทียบทางเลือกแปลสาบานตนยื่นสถานทูต
          </Link>
        </p>

        <p className="mt-8 text-xs text-muted-foreground">
          ไม่แสดงราคาบริการบนหน้าเว็บ — สอบถามค่าบริการทางโทรศัพท์ 094-895-8999 LINE @Thainotary หรืออีเมล
          ค่าธรรมเนียมราชการเป็นอัตราของหน่วยงานและแสดงแยกจากค่าบริการเสมอ
        </p>
      </section>
    </>
  );
}
